export enum DEFAULT_NUMBER {
    // LONGITUDE = -31.9880527,
    // LATITUDE = 115.76528570000005,
    SINGLE_DAY_TYPE_LOCATION_SIZE = 4,
    BOTH_DAY_TYPE_LOCATION_SIZE = 2,
    MOBILE_LOCATION_SIZE = 3,
}
